export enum CrudActionType {
    CADASTRAR,
    ATUALIZAR,
    VISUALIZAR,
    EXCLUIR,
    NADA
}